import { User } from "../user/User"

export class Note {
  id: number
  content: string
  customerVisible: boolean
  lastModifiedByUser?: User
  lastModifiedDate?: string

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, content?: string|undefined, customerVisible?: boolean|undefined, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    this.id = id
    this.content = content ?? ''
    this.customerVisible = customerVisible ?? false
    this.lastModifiedByUser = lastModifiedByUserJson ? new User(lastModifiedByUserJson) : undefined
    this.lastModifiedDate = lastModifiedDate
  }
}
